import React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../../vars/colors';
import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters';
import { Row } from '../../global/grid/grid';

export const CaseStudyThumbWrapper = styled(Row)`
    position: relative;
    padding-bottom: calc(${gutters['container-gutters-desktop-l']} * 0.7);
    @media (max-width: ${breakpoints['bp-desktop']}) {
        padding-bottom: calc(${gutters['container-gutters-desktop']} * 0.7);
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        padding-bottom: calc(${gutters['container-gutters-tablet']} * 0.7);
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        padding-bottom: calc(${gutters['container-gutters-mobile']} * 2);
    }
    ${props => props.thumbStyle === 'alternate' && css`
        padding-top: calc(${gutters['container-gutters-desktop-l']} * 0.7);
        @media (max-width: ${breakpoints['bp-desktop']}) {
            padding-top: calc(${gutters['container-gutters-desktop']} * 0.7);
        }
        @media (max-width: ${breakpoints['bp-tablet']}) {
            padding-top: calc(${gutters['container-gutters-tablet']} * 0.7);
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            padding-top: calc(${gutters['container-gutters-mobile']} * 0.7);
        }
    ` 
    }
    .thumbImageWrapper {
        position: relative;
        width: 100%;
        ${props => props.direction === 'left' && css`
            @media (max-width: ${breakpoints['bp-mobile']}) {
                margin-left: calc(${gutters['container-gutters-mobile']} * -1);
            }
        `
        }
        ${props => props.direction === 'right' && css`
            @media (max-width: ${breakpoints['bp-mobile']}) {
                margin-left: calc(${gutters['container-gutters-mobile']} * 1);
            }
        `
        }
        &:hover {
            .stripes {
                animation-play-state: paused;
            }
            .circleLabel {
                animation-play-state: paused;
            }
        }        
    }
    .frameHolder {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        box-sizing: border-box;
        border: solid 8px #ffffff;
        @media (max-width: ${breakpoints['bp-mobile']}) {
            display: none;
        }
    }
    .dataCounter {        
        position: absolute;
        top: 80px;
        ${props => props.direction === 'left' && css`
            right: -30px;
            `
        }       
        ${props => props.direction === 'right' && css`
            left: -30px;
            `
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            display: none;
        }
        .circleLabel {                        
            animation-name: spinCircle;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-duration: 10000ms;
            animation-play-state: running;
            @keyframes spinCircle {
                0% {transform: rotate(0deg)}
                100% {transform: rotate(360deg)}
            }
        }
        &.ctaHovered {
            .circleLabel {
                animation-play-state: paused;
            }            
        }
    }
    .colorBlock { 
        position: absolute;
        overflow: hidden;
        &.main {
            top: 55%;
            left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            right: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
            z-index: -1;
            @media (max-width: ${breakpoints['bp-desktop']}) {                
                left: calc(${gutters['container-gutters-desktop']} * -0.8);
                right: calc(${gutters['container-gutters-desktop']} * -0.8);
                bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                left: calc(${gutters['container-gutters-tablet']} * -0.8);
                right: calc(${gutters['container-gutters-tablet']} * -0.8);
                bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                top: 20%;
                left: calc(${gutters['container-gutters-mobile']} * -5);
                right: calc(${gutters['container-gutters-mobile']} * -5);
                bottom: calc(${gutters['container-gutters-mobile']} * -2);
            }
        }
        &.alternate {            
            z-index: -1;
            ${props => props.direction === 'right' && css`
                left: 55%;
                top: calc(${gutters['container-gutters-desktop-l']} * -0.7);
                right: calc(${gutters['container-gutters-desktop-l']} * -0.8);
                bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
                @media (max-width: ${breakpoints['bp-desktop']}) {
                    top: calc(${gutters['container-gutters-desktop']} * -0.7);
                    right: calc(${gutters['container-gutters-desktop']} * -0.8);
                    bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
                }
                @media (max-width: ${breakpoints['bp-tablet']}) {
                    top: calc(${gutters['container-gutters-tablet']} * -0.7);
                    right: calc(${gutters['container-gutters-tablet']} * -0.8);
                    bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
                }
                @media (max-width: ${breakpoints['bp-mobile']}) {             
                    top: 20%;
                    left: calc(${gutters['container-gutters-mobile']} * -5);
                    right: calc(${gutters['container-gutters-mobile']} * -5);
                    bottom: calc(${gutters['container-gutters-mobile']} * -2);
                }
            `
            }
            ${props => props.direction === 'left' && css`
                right: 55%;
                top: calc(${gutters['container-gutters-desktop-l']} * -0.7);
                left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
                bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
                @media (max-width: ${breakpoints['bp-desktop']}) {
                    top: calc(${gutters['container-gutters-desktop']} * -0.7);
                    left: calc(${gutters['container-gutters-desktop']} * -0.8);
                    bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
                }
                @media (max-width: ${breakpoints['bp-tablet']}) {
                    top: calc(${gutters['container-gutters-tablet']} * -0.7);
                    left: calc(${gutters['container-gutters-tablet']} * -0.8);
                    bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
                }
                @media (max-width: ${breakpoints['bp-mobile']}) {
                    top: 20%;
                    left: calc(${gutters['container-gutters-mobile']} * -5);
                    right: calc(${gutters['container-gutters-mobile']} * -5);
                    bottom: calc(${gutters['container-gutters-mobile']} * -2);
                }
            `
            }
        }
        .stripes {
            position: absolute;
            top: -75px;
            left: -75px;
            right: -75px;
            bottom: -75px;
            background: repeating-linear-gradient(-45deg, ${props => props.color === 'blue' ? colors['peacock-blue'] : colors['lipstick']}, ${props => props.color === 'blue' ? colors['peacock-blue'] : colors['lipstick']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
            animation-name: barbersPole;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-duration: 1200ms;
            animation-play-state: running;
            @keyframes barbersPole {
                0% {transform: translate3d(0, 0, 0)}
                100% {transform: translate3d(0, 72px, 0)}
            }
            &.ctaHovered {
                animation-play-state: paused;
            }
        }
    }
    .thumbTextHolder {
        width: 100%;
        flex: 1 1 auto;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: relative;
        .rotatedText {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            transform: rotate(-90deg);
            display: flex;
            flex-direction: column;
            justify-content: center;
            transform-origin: center center;
            .city {
                font-family: 'OneDotExt', sans-serif;
                font-weight: bold;
                font-size: 40px;
                text-transform: uppercase;
                color: ${ props => props.color === 'red' ? colors['lipstick'] : colors['peacock-blue'] };
                @media (max-width: ${breakpoints['bp-tablet']}) {
                    font-size: 30px;
                }
            }
            .state {
                margin-top: 15px;
                font-family: 'OneDotExt', sans-serif;
                font-weight: bold;
                font-size: 24px;
                text-transform: uppercase;
                color: ${colors['black']};
            }
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            .rotatedText {
                position: relative;
                width: 100%;
                transform: none;
                margin: 0 15%;
                margin-bottom: 10px;
                .city {
                    font-size: 30px;
                }
                .state {
                    font-size: 16px;
                    margin-top: 5px;
                }
            }
        }
    }
    .initialsHolder {
        font-family: 'OneDotCd', sans-serif;
        font-weight: bold;
        color: ${colors['white-two']};
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        font-size: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 10px;
        z-index: -2;
        text-transform: uppercase;
        @media (max-width: ${breakpoints['bp-tablet']}) {
            font-size: 250px;
        }
    }
    .ctaHolder {
        width: 150px;
        position: relative;
        flex: 0 0 30%;
        transition: transform 300ms ease-in-out;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .ctaText {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: 'OneDotCd', sans-serif;
            font-style: italic;
            text-transform: uppercase;
            font-size: 18px;
            color: white;
            &.left {
                left: 20%;
            }
            &.right {
                right: 20%;
            }
        }
        &:hover {
            transform: translate3d(0, -5px, 0) scale(1.02);
        }
    }
    .mobileWrapper {
        .ctaHolder {
            position: absolute;
            ${ props => props.direction === 'left' && css`
                right: 55px;
            ` }
            ${ props => props.direction === 'right' && css`
                left: 55px;
            ` }            
            z-index: 4;
            bottom: 60px;            
            background: ${ props => props.color === 'red' ? colors['lipstick'] : colors['peacock-blue']};
            display: inline-block;
            height: 50px;
            width: 100px;
            border-radius: 3px;
            .ctaText {
                left: 0;
                top: 0;
                width: 100%;
            }
            svg {
                display: none;
            }
        }
        .initialsHolder {
            position: absolute;
            top: -175px;
            font-size: 250px;
            @media (max-width: ${breakpoints['bp-mobile']}) {
                display: none;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/modules/CaseStudyThumb/styled-components.js